module.exports = "/_next/static/images/wagon-5787f8709e244e8d3d7bc4c353a2fa73.jpg";